// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--dxEHz","rate":"a10a3f92e9--rate--jhGPH"};